import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const Illustration = require('ressources/images/signin.jpeg')

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        height: '100vh',
        width: '100%',
    },
    signInSection: {
        padding: '24px 64px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: theme.spacing(3)
    },
    arcaneFaviconDiv: {
        position: 'absolute',
        top: 15,
        left: 15
    },
    footpageDiv: {
        position: 'absolute',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)'
    },
    secondaryTypography: {
        color: theme.palette.text.secondary,
    },
    arcaneFavicon: {
        height: '35%',
         width: '35%'
    },
    smartfeedsLogo: {
        maxWidth: 216
    },
    illustrationSection: {
        height: '100%',
        width: '100%',
        background: theme.palette.background.default,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: `url(${Illustration})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100vh'
    },
    contactUsLink: {
        textDecoration: 'none',
        color: theme.palette.text.secondary,
    },
    contactUsDiv: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
    },
    divider: {
        maxWidth: '288px',
        width: '100%',
    },
    welcomeText: {
        color: theme.palette.primary.main
    }
}))
